module.exports = __webpack_public_path__ + "static/media/Unselected.4cc1e736.svg";